import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { PsBeaconNotification } from '../BeaconRegister';



export default function AppErrorAlert({ dialogTitle, dialogText, dismissable = true, close }) {

    return (
        <Box className='b-container-content' sx={{ inlineSize: 'unset !important', paddingTop: '16px' }}>
            <PsBeaconNotification
                type='toast'
                variant='error'
                dismissable={dismissable}
                onBeaconEventDismiss={close}>
                <div>{dialogTitle}</div>
                <div slot='description'>{dialogText}</div>
            </PsBeaconNotification>
        </Box>
    );
}
